/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_points_data_through = /** @type {(inputs: { name: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Data current through ${i?.name}`)
};

const es_f1_points_data_through = /** @type {(inputs: { name: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Datos actualizados hasta ${i?.name}`)
};

const de_f1_points_data_through = /** @type {(inputs: { name: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Daten aktuell bis ${i?.name}`)
};

const nl_f1_points_data_through = /** @type {(inputs: { name: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gegevens bijgewerkt t/m ${i?.name}`)
};

const fr_f1_points_data_through = /** @type {(inputs: { name: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Données à jour jusqu’au ${i?.name}`)
};

const it_f1_points_data_through = /** @type {(inputs: { name: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dati aggiornati fino a ${i?.name}`)
};

const pt_br2_f1_points_data_through = /** @type {(inputs: { name: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dados atualizados até ${i?.name}`)
};

const pt_f1_points_data_through = /** @type {(inputs: { name: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dados atualizados até ${i?.name}`)
};

const ja_f1_points_data_through = /** @type {(inputs: { name: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`データ更新: ${i?.name}まで`)
};

const zh_f1_points_data_through = /** @type {(inputs: { name: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`数据更新至${i?.name}`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ name: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_points_data_through = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_points_data_through(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_points_data_through", locale)
	if (locale === "en") return en_f1_points_data_through(inputs)
	if (locale === "es") return es_f1_points_data_through(inputs)
	if (locale === "de") return de_f1_points_data_through(inputs)
	if (locale === "nl") return nl_f1_points_data_through(inputs)
	if (locale === "fr") return fr_f1_points_data_through(inputs)
	if (locale === "it") return it_f1_points_data_through(inputs)
	if (locale === "pt-BR") return pt_br2_f1_points_data_through(inputs)
	if (locale === "pt") return pt_f1_points_data_through(inputs)
	if (locale === "ja") return ja_f1_points_data_through(inputs)
	return zh_f1_points_data_through(inputs)
};